<script>
    import { mapActions } from "vuex";
    import ThePersonalIcon from "@/ThePersonal/components/ThePersonalIcon";

    export default {
        name: "ProfileNavigationList",
        components: {
            ThePersonalIcon,
        },
        computed: {
            routes() {
                return [
                    { title: "Главная", name: "ThePersonalMain", icon: "main" },
                    {
                        title: "Скидки и акции",
                        name: "ThePersonalDiscounts",
                        icon: "discounts",
                    },
                    { title: "Мои данные", name: "ThePersonalData", icon: "data" },
                    { title: "Мои заказы", name: "ThePersonalOrders", icon: "orders" },
                    { title: "Мои адреса", name: "ThePersonalAddresses", icon: "addresses" },
                    { title: "Кешбэк", name: "ThePersonalBonuses", icon: "bonuses" },
                    { title: "Помощь", name: "ThePersonalSupport", icon: "support" },
                ];
            },
        },
        methods: {
            ...mapActions("Root", ["getCart"]),
            ...mapActions("Profile", ["logoutProfile"]),
            logoutClickHandler() {
                this.logoutProfile().then(() => {
                    if (this.$route.name !== "Home") {
                        this.$router.push({ name: "Home" });
                    }
                    this.getCart();
                });
            },
        },
    };
</script>

<template>
    <ul class="profile-navigation-list">
        <li class="profile-navigation-list__item" v-for="route in routes" :key="route.name">
            <router-link
                class="profile-navigation-list__link"
                :class="{ 'is-active': $route.name === route.name }"
                :to="{ name: route.name }"
            >
                <img
                    v-if="route.icon === 'discounts'"
                    src="/static/assets/profile/icons/discounts.svg"
                    alt=""
                />
                <the-personal-icon v-else :name="route.icon"></the-personal-icon>
                <span>{{ route.title }}</span>
            </router-link>
        </li>
        <li class="profile-navigation-list__item">
            <button class="profile-navigation-list__link" @click="logoutClickHandler">
                <the-personal-icon name="exit"></the-personal-icon>
                <span>Выйти</span>
            </button>
        </li>
    </ul>
</template>

<style lang="scss">
    .profile-navigation-list {
        min-width: 240px;
        background-color: #fff;
        border: $personal-common-border-full;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            padding: 10px;
            box-shadow: $personal-common-shadow-max;
            border-radius: $personal-box-radius;
        }
    }

    .profile-navigation-list__item {
        &:last-child {
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                right: 10px;
                left: 10px;
                height: 1px;
                background-color: $personal-divider-fill;
            }
        }
    }

    .profile-navigation-list__link {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px 20px;
        color: $personal-nav-color;
        font-family: $personal-nav-font;
        font-size: $personal-nav-size;
        font-weight: $personal-nav-weight;
        line-height: 20px;
        text-transform: $personal-nav-case;
        transition: background-color 0.2s ease-in, color 0.2s ease-in;
        -webkit-tap-highlight-color: transparent;
        svg,
        img {
            @include box(16px);
            margin-right: 10px;
            fill: $personal-nav-color;
            stroke: $personal-nav-color;
            transition: fill 0.2s ease-in, stroke 0.2s ease-in;
        }
        &.is-active {
            color: $personal-nav-color--active;
            background-color: $personal-nav-fill;
            svg {
                fill: $personal-nav-color--active;
                stroke: $personal-nav-color--active;
            }
        }
        @include bp($bp-desktop-sm) {
            padding: 12px;
            border-radius: $personal-nav-radius;
            &:focus-visible {
                @include outline(-2px);
            }
            &:hover {
                background-color: $personal-nav-fill;
            }
        }
    }
</style>
